import Modal from "modal/Modal";
import FormValidator from "base/FormValidator";
import debounce from "debounce";
import GalleryItemVideo from "gallery/video/GalleryItemVideo";
import Message from "base/Message";
import Ajax from "base/Ajax";
import VideoHelper from "video/VideoHelper";

class AddVideoModal extends Modal {
    constructor(gallery) {
        super({class: "admin-modal--navigation"});
        this.gallery = gallery;

        this.updatePreview = debounce(this.updatePreview, 600);

        this.setContent(
            eotwJSXFactory('form', {class: "admin-form"}, [
                eotwJSXFactory('div', {class: "admin-modal__navigation"}, [
                    this.gallery.data.profile.allowImages ? eotwJSXFactory('button', {class: "admin-modal__link js-add-image", type: "button"}, ["Add Image"]) : [],
                    eotwJSXFactory('button', {class: "admin-modal__link admin-modal__link--active", type: "button"}, ["Add Video"])
                ]),
                eotwJSXFactory('h2', null, ["Add a Video"]),
                eotwJSXFactory('p', null, ["Enter the URL of the video below. You can enter videos from Youtube.com or Vimeo.com, but the video will need to have the correct settings, such as allowing external embeds."]),
                eotwJSXFactory('div', {class: "admin-form__row"}, [
                    eotwJSXFactory('label', {class: "admin-form__label", for: "video-url"}, ["Video URL"]),
                    eotwJSXFactory('input', {type: "text", class: "js-url admin-form__input", id: "video-url", name: "url", 'data-name': "video url"}),
                    eotwJSXFactory('span', {class: "form__inline-validation js-inline-validation"})
                ]),
                eotwJSXFactory('div', {class: "admin-form__row admin-gallery__row js-video-details", style: "display:none"}, [
                    eotwJSXFactory('div', {class: "admin-gallery__video"}, [
                        eotwJSXFactory('img', {class: "js-thumbnail"})
                    ]),
                    eotwJSXFactory('div', {class: "admin-gallery__info"}, [
                        eotwJSXFactory('span', {class: "admin-gallery__title js-title"}),
                        eotwJSXFactory('span', {class: "admin-gallery__duration js-provider"})
                    ])
                ]),
                eotwJSXFactory('div', {class: "admin-modal__buttons"}, [
                    eotwJSXFactory('button', {class: "admin-btn admin-btn--confirm admin-btn--modal", type: "submit"}, ["Continue"]),
                    eotwJSXFactory('button', {class: "admin-btn admin-btn--cancel admin-btn--modal js-cancel", type: "button"}, ["Cancel"])
                ])
            ])
        );

        FormValidator.attach(this.$content).on("submit", ($form) => {
            let $btn = $form.find("button[type='submit']");
            if ($btn.is(".admin-btn--loading")) return;
            $btn.addClass("admin-btn--loading");

            Ajax.post("gallery", "items", {
                type: 1,
                url: $form.find(".js-url").val()
            }).then((data) => {
                let item = GalleryItemVideo.process_item(this.gallery, data);

                let modal = item.getModal();
                modal.on("cancel", () => this.emit("cancel") && this.hide());
                modal.on("okay", () => this.emit("videos", [item]));

                modal.show();
            }).catch((e) => {
                console.error(e);
                $btn.removeClass("admin-btn--loading");
                new Message(e.message, "Couldn't add the video");
            })
        });
        this.show();
        this.on("click", ".js-add-image", () => {
            this.emit("cancel");
            this.destroy();
            this.gallery.showAddImage();
            return false;
        });
        this.on("change keypress paste", ".js-url", () => this.updatePreview() && false);
        this.on("click", ".js-cancel", () => this.emit("cancel") && this.hide() && false);

    }

    updatePreview() {
        let value = this.$element.find(".js-url").val();

        if (value === this.lastCheckedValue) return;
        this.lastCheckedValue = value;

        if (this.updatePreviewAjax) this.updatePreviewAjax.abort();

        VideoHelper.get_video_details(value).then((data) => {
            if (value !== this.lastCheckedValue) return;

            this.$content.find(".js-title").text(data.name);
            this.$content.find(".js-thumbnail").attr("src", data.image);
            this.$content.find(".js-duration").text(data.duration);
            this.$content.find(".js-provider").text(data.provider);
            this.$content.find(".js-video-details").show();
        }).catch((message) => {
            if (value !== this.lastCheckedValue) return;

            this.$content.find(".js-url").data("Validator").showMessage(message);
            this.$content.find(".js-video-details").hide();
        });
    }
}

export default AddVideoModal;
